import { CustomAction } from '@nimmsta/ng-commons-lib/data-table';
import { Observable, of } from 'rxjs';
import { WorkflowEvent } from '../models/workflowEvent';

export class DownloadDataAction extends CustomAction<WorkflowEvent> {
  constructor(
    _text: string,
    isDelete = false,
  ) {
    super(_text, false, isDelete);
  }

  override isEnabled(item: WorkflowEvent): Observable<boolean> {
    if (!item.urls) {
      return of(false);
    }
    return of(item.urls.filter((url) => url.indexOf('data.json') > 0).length > 0);
  }
}
